import { useEffect, useState } from 'react';

import {
  Alert,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { ICoSettlementAgentObj } from '../../../../../types/SettlementAgent';
import TermOfUse from '../../TermOfUse';

interface InviteCoSaPreviewProps {
  coSaListToPreview: Map<number, ICoSettlementAgentObj> | undefined;
  confirmChecked: (checked: boolean) => void;
}

const InviteCoSaPreview = (props: InviteCoSaPreviewProps) => {
  const { coSaListToPreview, confirmChecked } = props;
  const [open, setOpen] = useState(false);

  const [confirmState, setConfirmState] = useState({
    termOfUse: false,
    privacyPolicy: false,
  });
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmState({
      ...confirmState,
      [event.target.name]: event.target.checked,
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const { termOfUse, privacyPolicy } = confirmState;

  useEffect(() => {
    confirmChecked(termOfUse && privacyPolicy);
  }, [confirmState]);

  return (
    <>
      <Alert
        severity='info'
        sx={{
          mb: 2,
        }}>
        Please carefully review the information below. Adding a Co-Settlement
        Agent to this order is a permanent action and cannot be undone. Please
        acknowledge you have reviewed the information by completing the
        checkmarks below.
      </Alert>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label='a dense table'>
          <TableHead>
            <TableRow>
              <TableCell align='left'>Email</TableCell>
              <TableCell align='left'>First Name</TableCell>
              <TableCell align='left'>Last Name</TableCell>
              <TableCell align='left'>Phone Number</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {coSaListToPreview &&
              Array.from(coSaListToPreview.values()).map((row) => (
                <TableRow
                  key={row.Id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell align='left' data-testid='sa-email'>
                    {row.Email}
                  </TableCell>
                  <TableCell align='left'>{row.FirstName}</TableCell>
                  <TableCell align='left'>{row.LastName}</TableCell>
                  <TableCell align='left'>{row.PhoneNumber}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <FormGroup>
        <FormControlLabel
          required
          control={
            <Checkbox
              checked={termOfUse}
              onChange={handleChange}
              name='termOfUse'
            />
          }
          label={
            <Typography variant='caption' sx={{ marginTop: '2px' }}>
              By selecting “Add Co-Settlement Agents” you are confirming that
              you have read and agree to
              <Link
                target='_blank'
                href='https://www.firstam.com/privacy-policy/#type-of-information'>
                <strong> privacy policy </strong>
              </Link>
              and
              <Link target='_blank' onClick={() => handleClickOpen()}>
                <strong> Terms of Use</strong>
              </Link>
              .
            </Typography>
          }
        />
        <FormControlLabel
          required
          control={
            <Checkbox
              checked={privacyPolicy}
              onChange={handleChange}
              name='privacyPolicy'
            />
          }
          label={
            <Typography variant='caption' sx={{ marginTop: '1px' }}>
              I confirm these Co-Settlement Agents should be added to this order
              and acknowledge that this action is permanent and cannot be
              undone.
            </Typography>
          }
        />
      </FormGroup>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={'paper'}
        aria-labelledby='scroll-dialog-title'
        aria-describedby='scroll-dialog-description'
        fullWidth
        maxWidth={'md'}>
        <DialogTitle id='scroll-dialog-title'>Term of Use</DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText id='scroll-dialog-description' tabIndex={-1}>
            <TermOfUse />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default InviteCoSaPreview;
